<template>
  <div>
    <AdminHeader></AdminHeader>
    <div class="news_form">
      <span>編輯新消息</span>
      <form v-if="newsInfo">
        <div class="form_title">
          <label for="title">標題</label>
        </div>
        <div class="form_content">
          <input id="title" name="title" type="text" v-model="newsInfo.title" />
        </div>
        <div class="form_title">
          <label for="time">時間</label>
        </div>
        <div class="form_content">
          <datepicker
            :clear-button="true"
            :calendarButton="true"
            :calendar-button-icon="icon"
            class="input_date"
            placeholder="選擇發佈日期"
            v-model="newsInfo.created_at"
          ></datepicker>
        </div>
        <div class="form_title title-name">
          <div class="content">內文</div>
        </div>
        <div class="form_content">
          <textarea rows="10" cols="50" v-model="newsInfo.body"></textarea>
        </div>
      </form>
      <div class="load" v-else>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <button class="delete" @click="deleteNews">刪除</button>
      <button class="release" @click="updateNews">發佈</button>
      <button class="cancel" @click="cancel">取消</button>
    </div>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/admin_header.vue";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import "../../scss/_datepicker_plugin.scss";

export default {
  name: "admin_edit_news",
  components: {
    AdminHeader,
    Datepicker,
  },
  data() {
    return {
      icon: "fa fa-calendar",
      id: "",
      newsInfo: "",
    };
  },
  watch: {
    "newsInfo.created_at": function () {
      if (
        Object.prototype.toString.call(this.newsInfo.created_at) ===
        "[object Date]"
      ) {
        let month = this.zeroFill(
          (this.newsInfo.created_at.getMonth() + 1).toString(),
          2
        );
        let day = this.zeroFill(
          this.newsInfo.created_at.getDate().toString(),
          2
        );
        this.newsInfo.created_at =
          this.newsInfo.created_at.getFullYear() + "-" + month + "-" + day;
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getNewsInfo();
  },
  methods: {
    getNewsInfo() {
      axios({
        url: this.$store.getters.getGlobalUrl + `admin/news/${this.id}`,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          this.newsInfo = response.data.data;
        })
        .catch((e) => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    deleteNews() {
      let userResponse = confirm("您確定要刪除此筆消息嗎？");
      if (userResponse) {
        axios({
          url: this.$store.getters.getGlobalUrl + `admin/news/${this.id}`,
          method: "delete",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
          .then(() => {
            alert("成功刪除消息");
            this.$router.push("/admin/latest_newsList");
          })
          .catch((e) => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      }
    },
    updateNews() {
      axios({
        url: this.$store.getters.getGlobalUrl + `admin/news/${this.id}`,
        method: "put",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: this.newsInfo,
      })
        .then(() => {
          alert("成功發佈");
          this.$router.push("/admin/latest_newsList");
        })
        .catch((e) => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    cancel() {
      let userResponse = confirm(
        "您編輯的資料可能會遺失，確定放棄此次編輯嗎？"
      );
      if (userResponse) {
        this.$router.push("/admin/latest_newsList");
      }
    },
    zeroFill(now, fillLength) {
      if (now.length < fillLength) {
        let fillNum = fillLength - now.length + 1;
        return new Array(fillNum).join("0").concat(now);
      }
      return now;
    },
  },
};
</script>

<style scoped lang="scss">
.news_form {
  padding: 50px;
  form {
    display: grid;
    grid-template-columns: 50px 1fr;
    margin-top: 30px;
    .content {
      display: inline;
    }
  }
  .title-name {
    margin-top: 15px;
  }
  .form_content {
    align-self: center;
  }
  label {
    font-size: 17px;
    letter-spacing: 2px;
    color: #4a4a4a;
    line-height: 4;
  }
  input {
    height: 35px;
  }
  .vdp-datepicker input {
    height: 39px;
  }
  .form_content textarea {
    margin-top: 15px;
  }
  input,
  textarea,
  .input_date {
    border: 1px #979797 solid;
    font-size: 17px;
    width: 480px;
    margin: 0;
  }
}
span {
  font-size: 20px;
  letter-spacing: 2px;
}
button {
  font-size: 17px;
  width: 120px;
  height: 35px;
  margin-left: 10px;
}
.delete {
  margin: 10px 0 0 50px;
  background-color: #fd4c5e;
  color: #fff;
  &:hover {
    background-color: darken(#fd4c5e, 10%);
  }
}
.release {
  color: #fff;
  background-color: #4a90e2;
  &:hover {
    background-color: darken(#4a90e2, 10%);
  }
}
.cancel {
  border: 1px #ddd solid;
  a {
    color: #4a4a4a;
  }
  &:hover {
    background-color: darken(#fff, 10%);
  }
}
//loading
.load {
  display: flex;
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #2275d7;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
